import { render, staticRenderFns } from "./AssignSlot.vue?vue&type=template&id=a5e6c158&scoped=true&lang=pug&"
import script from "./AssignSlot.vue?vue&type=script&lang=js&"
export * from "./AssignSlot.vue?vue&type=script&lang=js&"
import style0 from "./AssignSlot.vue?vue&type=style&index=0&id=a5e6c158&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5e6c158",
  null
  
)

export default component.exports